<template>
  <div class="modal fixed">
    <div class="modal-content">
      <button class="modal-button" @click="gotClose(false)">
        <BaseIcon name="window-close" class="icon" />
      </button>
      <h2 class="modal-title">Edit IPC &amp; Final Inspection</h2>
      <form @submit.prevent="editInspection">
        <div class="multiple-div" name="step3">
          <label>Technical Drawing</label>
          <ImageInput v-model="deviceDrawing">
            <div slot="activator">
              <div v-if="!deviceDrawing" class="image-selector">
                <img src="@/assets/images/drawing-select@2x.png" alt="avatar" />
              </div>
              <div v-else class="image-selector selected">
                <img :src="deviceDrawing.base64" alt="device image" />
              </div>
            </div>
          </ImageInput>
          <ImageDrawCanvas
            @closeDrawing="stopImageDrawing"
            :currentImage="deviceDrawing"
            v-if="isDrawingViewOpen"
            @drawingComplete="saveArrows"
          />
          <label class="margin-top">Inspection Requirements</label>
          <StaticCustomValueList
            v-if="receivedArrows > 0"
            label="Inspection Requirements"
            name="InspectionRequirements"
            :neededValues="receivedArrows"
            :values="inspectionRequirements"
            @updateValues="gotRequirements"
          />
          <span class="no-requirements" v-else
            >No Requirements selected/needed</span
          >
          <div>
            <label for="deviations">IPC</label>
            <InputToggle
              @toggle="toggleDev"
              :isChecked="this.IPC"
              :isDisabled="false"
            />
          </div>
          <label class="margin-top">Defaults - Final inspection</label>
          <select
            name="final-defaults"
            multiple
            v-model="finDefaults"
            class="multiple-select"
          >
            <option value="complete">Complete</option>
            <option value="burs">Burs</option>
            <option value="visual">Visual</option>
            <option value="functionality">Functionality</option>
          </select>
        </div>
        <div class="buttons">
          <BaseButton
            type="button"
            :key="1"
            color="tertiary"
            size="modal-sm"
            @click.native="gotClose(true)"
            >Cancel</BaseButton
          >
          <BaseButton type="submit" :key="3" color="primary" size="modal-sm"
            >Save</BaseButton
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";
import ImageInput from "@/components/base/ImagePDFInput.vue";

// import ImageInput from '@/components/base/ImageInput'
import ImageDrawCanvas from "@/components/ImageDrawCanvas";
import StaticCustomValueList from "@/components/base/StaticCustomValueList";
import InputToggle from "@/components/base/InputToggle";

export default {
  components: {
    BaseIcon,
    BaseButton,
    ImageInput,
    ImageDrawCanvas,
    StaticCustomValueList,
    InputToggle,
  },
  props: {
    selectedItem: Object,
  },
  data() {
    return {
      isDrawingViewOpen: false,
      finalBase64: "",
      IPC: false,
      deviceDrawing: null,
      saving: false,
      saved: false,
      receivedArrows: 0,
      finDefaults: [],
    };
  },
  created() {
    let that = this;
    document.addEventListener("keyup", function (evt) {
      if (evt.keyCode === 27) {
        that.gotClose(false);
      }
    });
  },
  mounted() {
    this.currentRoute = this.$router.currentRoute.name;

    // set ipc toggle for edit
    if (this.selectedItem.ipc.length >= 1) {
      this.IPC = true;
    } else {
      this.IPC = false;
    }
  },
  methods: {
    editInspection() {
      var url, params;
      var that = this;

      this.inValidFields = [];

      let filteredRequirements = that.inspectionRequirements.filter(function (
        el
      ) {
        return (
          el.letter != "" && el.inspectionName != "" && el.inspectionType != ""
        );
      });
      console.log(that.inspectionRequirements,'req')
      if (
        filteredRequirements == null ||
        filteredRequirements == undefined ||
        filteredRequirements.length != that.inspectionRequirements.length
      ) {
        this.inValidFields.push("filteredRequirements");
      }

      var filteredIPCRequirements = [];

      for (let i = 0; i < filteredRequirements.length; i++) {
        if (this.IPC) {
          filteredIPCRequirements.push({
            letter: filteredRequirements[i].letter,
            IPCType: filteredRequirements[i].inspectionType,
            IPCName: filteredRequirements[i].inspectionName,
          });
        }
      }

      if (!this.IPC) filteredIPCRequirements = [];

      var filteredFinalRequirements = [];
      for (let i = 0; i < filteredRequirements.length; i++) {
        if (filteredRequirements[i].isIPC == false) {
          filteredFinalRequirements.push(filteredRequirements[i]);
        }
      }

      for (let d = 0; d < this.finDefaults.length; d++) {
        filteredFinalRequirements.push({
          letter: "bool",
          inspectionName: this.finDefaults[d],
          inspectionType: "NOK - OK",
          isIPC: false,
        });
      }
      switch (this.selectedItem.type) {
        case "single":
          url = this.$endpoint + "management/devices/part";
          params = {
            bonPartID: this.selectedItem.deviceID,
            rawMaterialID: parseInt(this.selectedItem.rawMaterialID),
            ref: this.selectedItem.ref,
            description: this.selectedItem.description,
            flowID: this.selectedItem.flowID,
            typeBonID: "1",
            image: this.deviceDrawing.base64,
            imageEdit: "1",
            inspection: filteredFinalRequirements,
            ipc: filteredIPCRequirements.length > 0 ? "1" : "0",
            IPC: filteredIPCRequirements,
          };
          break;
        case "subpart":
          url = this.$endpoint + "management/devices/part";
          params = {
            bonPartID: this.selectedItem.deviceID,
            ref: this.selectedItem.ref,
            rawMaterialID: parseInt(this.selectedItem.rawMaterialID),
            description: this.selectedItem.description,
            flowID: this.selectedItem.flowID,
            typeBonID: "2",
            image: this.deviceDrawing.base64,
            imageEdit: "1",
            inspection: filteredFinalRequirements,
            ipc: filteredIPCRequirements.length > 0 ? "1" : "0",
            IPC: filteredIPCRequirements,
          };
          break;
        case "assembly":
          url = this.$endpoint + "management/devices/assembly";
          params = {
            assemblyID: this.selectedItem.deviceID,
            ref: this.selectedItem.ref,
            description: this.selectedItem.description,
            flowID: this.selectedItem.flowID,
            parts: this.selectedItem.parts,
            image: this.deviceDrawing.base64,
            imageEdit: "1",
            inspection: filteredFinalRequirements,
            ipc: filteredIPCRequirements.length > 0 ? "1" : "0",
            IPC: filteredIPCRequirements,
          };
          break;
      }
      if (that.inValidFields.length == 0 || this.selectedItem.type === 'assembly') {
        this.$http
          .put(url, params)
          .then(function (response) {
            that.$emit("closeModal", true);
            that.$swal(
              "Inspection edited!",
              `Your device has been successfully edited.`,
              "success"
            );
          })
          .catch(function (error) {
            console.log(error);
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          });
      } else {
        that.$swal(
          "Something isn't right!",
          `Some of the values are not filled in correctly.`,
          "error"
        );
      }
    },
    gotClose(val) {
      this.$emit("closeModal", val);
    },
    startImageDrawing() {
      this.isDrawingViewOpen = true;
    },
    stopImageDrawing() {
      this.isDrawingViewOpen = false;
    },
    uploadImage() {
      this.saving = true;
      this.isDrawingViewOpen = false;
      setTimeout(() => this.savedAvatar(), 1000);
    },
    savedAvatar() {
      this.saving = false;
      this.saved = true;
    },
    gotValues(newValues) {
      this.values = newValues;
    },
    toggleDev() {
      this.IPC = !this.IPC;
    },
    gotRequirements(newValues) {
      this.inspectionRequirements = newValues;
    },
    saveArrows(receivedDrawing) {
      this.inspectionRequirements = receivedDrawing.arrows;
      this.receivedArrows = receivedDrawing.arrows.length;
      this.deviceDrawing.base64 = receivedDrawing.dataURL;
      this.uploadImage();
    },
  },
  watch: {
    deviceDrawing: function (newVal, oldVal) {
      if (this.isDrawingViewOpen == true) {
        this.isDrawingViewOpen = false;
      } else {
        this.startImageDrawing();
      }
      this.saved = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

.fixed {
  position: fixed;
  left: 0;
  top: 0;
}

.image-selector,
.image-selector > img {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 280px;

  &:hover {
    cursor: pointer;
  }
}

label.margin-top {
  margin-top: 16px;
}
span.no-requirements {
  color: #6a6a6a;
  font-style: italic;
}

select[multiple] {
  font-size: 12px;
  width: 100%;
  color: #707070;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #efefef;
  outline: none;
  transition: 0.5s;
  font-weight: 500;
  background-color: #ffffff;
  resize: none;

  &:focus {
    border: 1px solid #707070;
  }

  option {
    padding: 6px 4px;

    &:checked {
      color: white !important;
      background: #03758b linear-gradient(0deg, #03758b 0%, #03758b 100%);
    }
  }
}
</style>
